import { render } from "./Gauge.vue?vue&type=template&id=45a410e8"
import script from "./Gauge.vue?vue&type=script&lang=js"
export * from "./Gauge.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__